import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { mutationOptions } from '@tanstack/angular-query-experimental';
import { AgentsService, AgentFeedbackRequestDTO } from '@libs/api';

export type AgentFeedbackMutationVars = {
  clientId: number;
  brandId: number;
} & AgentFeedbackRequestDTO;

@Injectable({ providedIn: 'root' })
export class AgentMutationsService {
  private readonly agentsBff = inject(AgentsService);

  submitFeedback() {
    return mutationOptions({
      mutationFn: (vars: AgentFeedbackMutationVars) =>
        lastValueFrom(
          this.agentsBff.agentsBffControllerSubmitFeedback(
            vars.clientId,
            vars.brandId,
            {
              traceRunId: vars.traceRunId,
              score: vars.score,
              reason: vars.reason,
              failureMode: vars.failureMode
            }
          )
        )
    });
  }
}
